"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XhrPluginsHelpersFactory = void 0;
const xhrPluginsHelpers_1 = require("./xhrPluginsHelpers");
class XhrPluginsHelpersFactory {
    static getXhrCheckInvalidateCacheHeader(getMobileConnector) {
        return new xhrPluginsHelpers_1.XhrPluginsHelpers(getMobileConnector).invalidateCache;
    }
}
exports.XhrPluginsHelpersFactory = XhrPluginsHelpersFactory;
//# sourceMappingURL=factory.js.map